<template>
  <b-card>
    <canvas ref="importances-chart" width="160" height="90" />
  </b-card>
</template>

<script>
import _ from 'lodash'
import Chart from 'chart.js'

import chartColors from '@/components/chart_colors.js'

// *****************************************************************************

class GenericChart {
  constructor(el, colnames, title) {
    this.el = el
    this.labels = colnames
    this.title = title
  }
  init() {
    this.real_chart = new Chart(this.el, {
      type: 'line',
      data: {
        labels: this.labels,
        datasets: [],
      },
      options: {
        responsive: true,
        hover: {
          mode: 'nearest',
          intersect: false,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        title: {
          display: true,
          text: this.title,
        },
        legend: {
          display: false,
        },
      },
    })
  }

  update(datasets, colnames) {
    this.labels = colnames
    this.real_chart.data.labels = this.labels
    this.real_chart.data.datasets = datasets
    this.real_chart.update()
  }
}

// *****************************************************************************

export default {
  name: 'BorutaChart',
  components: {},
  props: ['project_id', 'tracking_infos', 'colnames', 'title'],
  data() {
    return {
      chart_object: undefined,
      is_mounted: false,
      colors_list: [
        chartColors.blue,
        chartColors.red,
        chartColors.green,
        chartColors.yellow,
        chartColors.orange,
        chartColors.purple,
        chartColors.grey,
        chartColors.indigo,
        chartColors.pink,
        chartColors.teal,
        chartColors.cyan,
      ],
      datasets_options_base: {
        cubicInterpolationMode: 'monotone',
        fill: false,
        showLine: false,
      },
      chart_datasets: [],
    }
  },
  computed: {
    datasets() {
      return this.build_importance_datasets()
    },
  },
  watch: {
    colnames(nv, ov) {
      if (nv !== ov) {
        this.check_chart(true)
      }
    },
    datasets(nv, ov) {
      this.check_chart()
    },
  },
  mounted() {
    this.check_chart()
  },
  beforeDestroy() {
    this.destroy_chart()
  },
  methods: {
    destroy_chart() {
      if (this.chart_object) {
        this.chart_object.real_chart.destroy()
      }
    },
    check_chart(reinit = false) {
      if (_.isUndefined(this.chart_object) || reinit) {
        this.destroy_chart()
        this.chart_object = new GenericChart(
          this.$refs['importances-chart'],
          this.colnames,
          this.title
        )
        this.chart_object.init()
        this.chart_datasets = []
      }
      for (const dataset of this.datasets) {
        const existing_dataset = _.find(this.chart_datasets, {
          label: dataset.label,
        })
        if (_.isUndefined(existing_dataset)) {
          this.chart_datasets.push(dataset)
        } else {
          existing_dataset.data = dataset.data
        }
      }
      this.chart_object.update(this.chart_datasets, this.colnames)
    },

    build_importance_datasets() {
      const datasets = []

      const self = this
      function adapt_data(value) {
        const color = '#000000'
        const dataset = _.merge(
          {
            backgroundColor: color,
            borderColor: color,
          },
          self.datasets_options_base
        )
        dataset.data = value
        datasets.push(dataset)
      }

      const imp_history = this.tracking_infos['imp_history'] || []
      _.forEach(imp_history, adapt_data)

      return datasets
    },
  },
}
</script>
